import { render, staticRenderFns } from "./ImportConsultants.vue?vue&type=template&id=be2e145e&"
import script from "./ImportConsultants.vue?vue&type=script&lang=js&"
export * from "./ImportConsultants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports